/// <reference path="../../../typings/index.d.ts" />

module Meevo.Components {
    "use strict";
    declare var EventSource: any;
    declare var window: any;

    enum ReadyStateEnum {
        Connecting,
        Open,
        Closed
    }

    export class MeevoPushMessageHandler implements angular.IDirective {

        initiate(locationId?: number) {
            const token = window['bearerToken'];

            const source = new EventSource(`${this.appSettings.SERVER_EVENTS_API_URL}/event-stream?sse=${token}`);
            
            source.addEventListener("onMessage", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.PENDING_MESSAGES, data);
            });
            source.addEventListener("onDrawerClosed", ({ data }) =>  {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_CLOSED_BY_ANOTHER_WARNING, data);
            });
            source.addEventListener("onNoShow", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.NO_SHOW, data);
            });
            source.addEventListener("onMerchantAccountTipSettingUpdated", ({ data }) =>  {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.ENABLE_TIPS_SETTING_UPDATED, data);
            });
            source.addEventListener("onMeevoMessengerMessageReceived", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.MEEVO_MESSENGER_INBOUND_MESSAGE, data);
            });
            source.addEventListener("onMeevoMessengerMessageStatusChange", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_MESSAGE_STATUS, data);
            });
            source.addEventListener("onMeevoMessengerMessageeSmsStatusChange", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TWO_WAY_SMS_MESSAGE_STATUS, data); //Check If we'll need this listener
            });
            source.addEventListener("onMeevoMessengerUnsubscribeMessageReceived", ({ data }) => {
                if (_.contains(JSON.parse(data), this.identityService.current().userId)) this.reconnectToChanel(source);
            });
            source.addEventListener("onTippyTipsSelection", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TIPPY_TIPS_SELECTED, data);
            });
            source.addEventListener("onAutoLogOutUser", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.AUTO_LOGOUT_USER, data);
            });
            source.addEventListener("onOAuthTokenObtained", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_OBTAINED, data);
            });
            source.addEventListener("onOAuthCodeObtained", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_CODE_OBTAINED, data);
            });

            source.addEventListener("open", () => {
                this.pushMessageHandlerService.isOpen = true;
            });

            source.addEventListener("error", () => {
                this.pushMessageHandlerService.isOpen = false;
            });

            //this.scheduleTokenExpiration(token).then(_ => {
            //    this.reconnectToChanel(source);
            //});
        }

        /**
         * Renew token and close current eventStream
         * @param { EventSource } source
         */
        private reconnectToChanel(source: any): void {
            source.close();
            this.initiate();
        }

        /*
        private scheduleTokenExpiration(expiresAt: Date): ng.IPromise<any> {
            const deferred = this.$q.defer();
            if (!expiresAt) return deferred.promise;

            const expireDate = moment(expiresAt);
            const dateNow = moment();

            const expiresIn = moment.duration(expireDate.diff(dateNow)).as('milliseconds');

            if (expiresIn < 0) return deferred.promise;

            setTimeout(() => {
                deferred.resolve();
            }, expiresIn);

            return deferred.promise;
        }*/

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private $rootScope,
            private $location,
            private identityService,
            public $q: ng.IQService,
            private pushMessageHandlerService: PushMessageHandlerService) { }

        static factory(): angular.IDirectiveFactory {
            let svc = (appSettings,
                $rootScope,
                $location,
                identityService,
                $q,
                pushMessageHandlerService) => {
                return new MeevoPushMessageHandler(appSettings,
                    $rootScope,
                    $location,
                    identityService,
                    $q,
                    pushMessageHandlerService);
            };
            svc.$inject = ["meevo.AppSettings",
                "$rootScope",
                "$location",
                "meevo.components.common.IdentityService",
                "$q",
                "meevo.components.common.meevoPushMessageHandlerService"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.meevoPushMessageHandler", MeevoPushMessageHandler.factory());

    export class PushMessageHandlerService {
        isOpen: boolean = false;

        static factory(): Function {
            let svc = () => new PushMessageHandlerService()
            
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.meevoPushMessageHandlerService", PushMessageHandlerService.factory());
}
